import type { SaleCrmStageCount } from 'services/types/sale';

/**
 * Order the Etapa tabs follow the Salesforce funnel instead of row counts. The values come from a
 * Salesforce picklist, so any Etapa the CRM starts reporting outside this list is appended at the
 * end rather than dropped.
 */
const STAGE_ORDER = ['Revisión', 'Renuncia', 'Cierre exitoso', 'Perdido'];

export const sortStages = (stages: SaleCrmStageCount[]): SaleCrmStageCount[] =>
  [...stages].sort((a, b) => {
    const aIndex = STAGE_ORDER.indexOf(a.stage);
    const bIndex = STAGE_ORDER.indexOf(b.stage);
    if (aIndex === -1 && bIndex === -1) return a.stage.localeCompare(b.stage);
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });
